@let multipleAvatars = avatars()?.length > 1;
<div class="avatar-container"
     [class.multiple]="multipleAvatars"
     [class.new-design]="newDesign()"
     [style.width.px]="size()"
     [style.height.px]="size()"
     [style.border-radius]="radius()">
  @if (avatar()) {
    <img class="avatar-container__avatar"
         [ngSrc]="avatar()"
         [width]="size()"
         [height]="size()"
         [alt]="name()"
         [style.border-radius]="radius()">
  } @else if (multipleAvatars) {
    @for (item of avatars() | slice: 0: MAX_AVATARS_LENGTH; track item.id) {
      <app-user-avatar
        radius="24px"
        [size]="nestedAvatarSize()"
        [fontSize]="14"
        [avatar]="item.id"
        [name]="item.name">
      </app-user-avatar>
    }
  } @else {
    <span class="avatar-container__letter" [style.font-size.px]="fontSize() ?? calculatedFontSize()">
      {{ newDesign() ? initials() : firstLetterName() }}
    </span>
  }
</div>
